import { modalAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

import { BACKGROUND_COLORS } from '../tokens';
import { resolveColor } from '../utils';

// Styles
const {
  definePartsStyle,
  defineMultiStyleConfig,
} = createMultiStyleConfigHelpers(modalAnatomy.keys);

// Exports
export const Modal = defineMultiStyleConfig({
  baseStyle: definePartsStyle((props) => ({
    dialog: {
      backgroundColor: resolveColor(props, BACKGROUND_COLORS.white.base),
    },
  })),
});
